import api from './api';

// Get all active templates
export const getOfferTemplates = async (params = {}) => {
  const { category, page = 1, limit = 20 } = params;
  let url = `/offer-templates?page=${page}&limit=${limit}`;
  if (category) {
    url += `&category=${category}`;
  }
  const response = await api.get(url);
  return response.data;
};

// Get template categories
export const getTemplateCategories = async () => {
  const response = await api.get('/offer-templates/categories');
  return response.data;
};

// Get a single template by ID
export const getOfferTemplateById = async (id) => {
  const response = await api.get(`/offer-templates/${id}`);
  return response.data;
};

// Create a new template
export const createOfferTemplate = async (templateData) => {
  const response = await api.post('/offer-templates', templateData);
  return response.data;
};

// Update a template
export const updateOfferTemplate = async (id, templateData) => {
  const response = await api.put(`/offer-templates/${id}`, templateData);
  return response.data;
};

// Delete a template
export const deleteOfferTemplate = async (id) => {
  const response = await api.delete(`/offer-templates/${id}`);
  return response.data;
};

// Apply template (increment usage count)
export const applyTemplate = async (id) => {
  const response = await api.post(`/offer-templates/${id}/apply`);
  return response.data;
};

// Get user's templates
export const getUserTemplates = async (params = {}) => {
  const { page = 1, limit = 100 } = params;
  const response = await api.get(`/offer-templates/user/my-templates?page=${page}&limit=${limit}`);
  return response.data;
};

// Create offer from template
export const createOfferFromTemplate = async (templateId, offerData) => {
  const response = await api.post(`/offers/from-template/${templateId}`, offerData);
  return response.data;
};

// Get pre-built templates
export const getPreBuiltTemplates = async (params = {}) => {
  const { category, page = 1, limit = 50 } = params;
  let url = `/offer-templates/prebuilt?page=${page}&limit=${limit}`;
  if (category) {
    url += `&category=${category}`;
  }
  const response = await api.get(url);
  return response.data;
};

// Get pre-built templates by category
export const getPreBuiltTemplatesByCategory = async (category, params = {}) => {
  const { page = 1, limit = 50 } = params;
  const response = await api.get(`/offer-templates/prebuilt/${category}?page=${page}&limit=${limit}`);
  return response.data;
};

// Get pre-built templates by tags
export const getPreBuiltTemplatesByTags = async (tags, params = {}) => {
  const { page = 1, limit = 50 } = params;
  const tagsString = Array.isArray(tags) ? tags.join(',') : tags;
  const response = await api.get(`/offer-templates/prebuilt/tags/${tagsString}?page=${page}&limit=${limit}`);
  return response.data;
};

// Get pre-built templates by type and subtype
export const getPreBuiltTemplatesByType = async (type, subtype = null, params = {}) => {
  const { page = 1, limit = 50 } = params;
  let url = `/offer-templates/prebuilt/type/${type}?page=${page}&limit=${limit}`;
  if (subtype) {
    url += `&subtype=${subtype}`;
  }
  const response = await api.get(url);
  return response.data;
};

// Get ALL templates (both prebuilt and user templates) by type and subtype
export const getAllTemplatesByType = async (type, subtype = null, params = {}) => {
  const { page = 1, limit = 50 } = params;
  let url = `/offer-templates/all/type/${encodeURIComponent(type)}?page=${page}&limit=${limit}`;
  if (subtype) {
    url += `&subtype=${encodeURIComponent(subtype)}`;
  }
  console.log('🌐 API call URL:', url);
  const response = await api.get(url);
  return response.data;
};

// Convert user template to prebuilt template
export const convertToPrebuiltTemplate = async (templateId, templateData) => {
  const response = await api.post(`/offer-templates/${templateId}/make-prebuilt`, templateData);
  return response.data;
}; 